import * as types from "./types";

export const defaultState = {
  agreements: [],
  loading: false,
  errors: []   
};

const agreements = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_AGREEMENTS:           
      return {
        ...state,
        agreements: [...action.agreements],
        loading: action.loading        
      }     
    case types.FETCHING_AGREEMENTS:       
      return {
        ...state,
        loading: action.loading
      }     
    case types.ERROR_FETCHING_AGREEMENTS:        
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      }
    default:
      return state;
  }
};
export default agreements;
